/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina } from './PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina';
import {
  PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSON,
  PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSONTyped,
  PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaToJSON,
} from './PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina';
import type { PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant } from './PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant';
import {
  PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSON,
  PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSONTyped,
  PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantToJSON,
} from './PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant';

/**
 * @type PatchedConversationalAgentInferencerPolymorphic
 *
 * @export
 */
export type PatchedConversationalAgentInferencerPolymorphic =
  | ({ protocol: 'CELINA' } & PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina)
  | ({
      protocol: 'OPEN_AI_ASSISTANT';
    } & PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistant);

export function PatchedConversationalAgentInferencerPolymorphicFromJSON(
  json: any,
): PatchedConversationalAgentInferencerPolymorphic {
  return PatchedConversationalAgentInferencerPolymorphicFromJSONTyped(json, false);
}

export function PatchedConversationalAgentInferencerPolymorphicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedConversationalAgentInferencerPolymorphic {
  if (json == null) {
    return json;
  }
  switch (json['protocol']) {
    case 'CELINA':
      return Object.assign(
        {},
        PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSONTyped(json, true),
        { protocol: 'CELINA' } as const,
      );
    case 'OPEN_AI_ASSISTANT':
      return Object.assign(
        {},
        PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantFromJSONTyped(
          json,
          true,
        ),
        { protocol: 'OPEN_AI_ASSISTANT' } as const,
      );
    default:
      throw new Error(
        `No variant of PatchedConversationalAgentInferencerPolymorphic exists with 'protocol=${json['protocol']}'`,
      );
  }
}

export function PatchedConversationalAgentInferencerPolymorphicToJSON(
  value?: PatchedConversationalAgentInferencerPolymorphic | null,
): any {
  if (value == null) {
    return value;
  }
  switch (value['protocol']) {
    case 'CELINA':
      return PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaToJSON(value);
    case 'OPEN_AI_ASSISTANT':
      return PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerOpenAIAssistantToJSON(value);
    default:
      throw new Error(
        `No variant of PatchedConversationalAgentInferencerPolymorphic exists with 'protocol=${value['protocol']}'`,
      );
  }
}
